import axios from "axios"
import {getConfig,getMappingUtil} from "./utility";

const initialState = {
    overview: {person: [], link: [], site: []},
    lovs: [],
    mappings: [],
    selectedType: null,
    fetchingOverview: false,
    fetchingLovs: false,
    saving: false,
    fetchingMapping: false
};

const OVERVIEW_GET = "OVERVIEW_GET";
const TYPE_LOVS_GET = "TYPE_LOVS_GET";
const LOCAL_MAPPING_GET = "LOCAL_MAPPING_GET";
const LOV_SAVE = "LOV_SAVE";

export default (state = initialState, action) => {
    switch (action.type) {
        case OVERVIEW_GET:
            switch (action.status) {
                case 0:
                    return {...state, fetchingOverview: true};
                case 1:
                    return {...state, fetchingOverview: false, overview: action.overview};
                default:
                    return {...state, fetchingOverview: false}
            }
        case TYPE_LOVS_GET:
            switch (action.status) {
                case 0:
                    return {...state, fetchingLovs: true, selectedType: action.lovType};
                case 1:
                    return {...state, fetchingLovs: false, lovs: action.lovs};
                default:
                    return {...state, fetchingLovs: false}
            }
        case LOV_SAVE:
            switch (action.status) {
                case 0:
                    return {...state, saving: true};
                case 1:
                    return {...state, saving: false, lovs: action.lovs};
                default:
                    return {...state, saving: false}
            }
        case LOCAL_MAPPING_GET:
            switch (action.status) {
                case 0:
                    return {...state, fetchingMapping: true};
                case 1:
                    return {...state, fetchingMapping: false, mappings: action.mappings};
                default:
                    return {...state, fetchingMapping: false}
            }
        default:
            return state
    }
}

const getOverviewReq = () => ({type: OVERVIEW_GET, status: 0});
const getOverviewSuc = overview => ({type: OVERVIEW_GET, status: 1, overview});
const getOverviewErr = error => ({type: OVERVIEW_GET, status: -1, error});
export const getOverview = () => (dispatch, getState) => {
    dispatch(getOverviewReq());
    axios.get('/lov/manage/overview', getConfig(getState))
        .then(res => {
            dispatch(getOverviewSuc(res.data))
        })
        .catch(err => dispatch(getOverviewErr(err)))
};


const getLovsReq = lovType => ({type: TYPE_LOVS_GET, status: 0, lovType});
const getLovsSuc = lovs => ({type: TYPE_LOVS_GET, status: 1, lovs});
const getLovsErr = error => ({type: TYPE_LOVS_GET, status: -1, error});
export const getLovs = (type) => (dispatch, getState) => {
    console.log('Get LOVs', type);
    if (!type) return Promise.resolve();
    dispatch(getLovsReq(type));
    return axios.get(`/lov/manage/${type}`, getConfig(getState))
        .then(res => dispatch(getLovsSuc(res.data)))
        .catch(err => dispatch(getLovsErr(err)))
};

const saveLovReq = (lov, lovType) => ({type: LOV_SAVE, status: 0, lov, lovType});
const saveLovSuc = (lovs) => ({type: LOV_SAVE, status: 1, lovs});
const saveLovErr = error => ({type: LOV_SAVE, status: -1, error});
export const saveLov = (lov) => (dispatch, getState) => {
    const {selectedType} = getState().lovManage;
    dispatch(saveLovReq(lov, selectedType));
    axios.post(`/lov/manage/${selectedType}`, lov, getConfig(getState))
        .then(res => dispatch(saveLovSuc(res.data)))
        .catch(err => dispatch(saveLovErr(err)))
};

const getMappingReq = code => ({type: LOCAL_MAPPING_GET, status: 0, code});
const getMappingSuc = (mappings, code) => ({type: LOCAL_MAPPING_GET, status: 1, mappings, code});
const getMappingErr = error => ({type: LOCAL_MAPPING_GET, status: -1, error});
export const getMapping = (code) => {
    return getMappingUtil(code, "lovManage", getMappingReq, getMappingSuc, getMappingErr);
};


// WEBPACK FOOTER //
// ./src/js/reducers/lovManage.js